import { useEffect, useState } from "react";
import { builder } from "@builder.io/sdk";
import { Region } from "@/components/LocalWebsiteSelector/RegionSelectorModal";
import { useRouter } from "next/navigation";

const useRegionDropdownData = () => {
	const [regionDropdowns, setRegionDropdowns] = useState<Region[]>([]);
	const router = useRouter();

	const toggleModal = () => {
		const params = new URLSearchParams();
		if (params.has("showModal")) {
			params.delete("showModal");
		} else {
			params.set("showModal", "true");
		}
		router.push(`?${params.toString()}`, { scroll: false });
	};

	const closeModal = () => {
		const params = new URLSearchParams();
		params.delete("showModal");
		router.push(`?${params.toString()}`, { scroll: false });
	};

	useEffect(() => {
		const fetchRegions = async () => {
			try {
				const regions = await builder.getAll("local-regions");
				const mappedRegions = regions.map((region) => ({
					title: region?.data?.title,
					link: region?.data?.link,
					browserLanguageCode: region?.data?.browserLanguageCode,
				}));
				setRegionDropdowns(mappedRegions);
			} catch (error) {
				console.error("Error fetching regions:", error);
			}
		};

		fetchRegions();
	}, []);

	return { regionDropdowns, toggleModal, closeModal };
};

export default useRegionDropdownData;
